(function($) {
	'use strict';

	$.widget('msv.menu', {

		options: {
			menuType: null,
			mobileMenuWidth: null,
			mobileMenuOffset: 50,
			currentDesktopLevel1: null,
			currentMobileLevel2: null,
			currentScroll: 0,
			animateSpeed: 800,
			defaultOption: null,
			mobileItemsLeftPosition: [],
			searchTimeout: null,
			el: {}
		},

		_create: function() {
			$.fx.speeds._default = 300;
			var self = this;
			/**/
			this.options.el.body = $("body");
			this.options.el.menu = $(".menu");
			this.options.el.menuDouble = $(".menu__double");
			this.options.el.logo = $(".menu__logo");
			this.options.el.level1 = $(".menu__level1");
			this.options.el.level1Options = $(".menu__level1__options");
			this.options.el.level2 = $(".menu__level2");
			this.options.el.level2Holder = $(".menu__level2__holder");
			this.options.el.level2Options = $(".menu__level2__options");
			this.options.el.level3 = $(".menu__level3");
			this.options.el.level3Holder = $(".menu__level3__holder");
			this.options.el.level3Links = $(".menu__level3__links");
			this.options.el.level3Options = $(".menu__level3__options");
			this.options.el.mobileContainer = $(".menu__mobile__container");
			this.options.el.magnifier = $(".icon-magnifier");
			this.options.el.searchBar = $(".menu__level2__searchbar");
			this.options.el.searchField = $("#search");
			this.options.el.searchLabel = $(".menu__level3__search-label");
			this.options.el.burguer = $(".icon-burguer");
			this.options.defaultOption = $(".menu__level1__options").data('default-position');
			this.options.el.btnDropdown = $('.menu__form__toggle-list');
			this.options.el.dropdownList = $('.js-menu-list');
			this.options.el.formNet = $('.menu__form__container');
			/**/
			this._setMenuType();
			this._checkScroll();
			this._commonEvents();
			this._toggleList();
			this._formNet();
			$(window).resize(function() {
				self._setMenuType();
			});
			$(window).scroll(function() {
				self._checkScroll();
				if (self.options.el.body.hasClass('goingDown')) {
					self.options.el.dropdownList.hide()
					self.options.el.btnDropdown.removeClass('open')
				}
			});
			this._mobileEventsInit();
			//console.log('create');
		},

		_commonEvents: function() {
			var self = this;
			this.options.el.magnifier.click(function() {
				if ($(this).hasClass("cross")) {
					$('body').removeClass('searchOpened');
					self._closeSearchBar(self.options.menuType);
				}
				else {
					self._openSearchBar(self.options.menuType);
				}
			});
		},

		_desktopEvents: function() {
			//console.log("_desktopEvents");
			var self = this;
			/**/
			this.options.el.level1Options.on("click", "span", function(e) {
				var position = $(e.currentTarget).index() + 1;
				self._setDesktopMenuLevel1(position, true);

				var href = $(e.currentTarget).data("href");
				if (href && href != window.location.pathname)
					window.location.href = href;
			});
			/**/
			this.options.el.level2Holder.find("li a").hoverIntent(function(e) {
				var me = $(e.currentTarget);
				var myLevel1 = me.closest(".menu__level2__options").index();
				var myLevel2 = me.closest("li").index();
				self._showDesktopMenuLevel2(myLevel1 + 1, myLevel2 + 1);
			}, function() {}, {
				interval: 300
			});
			/**/
			this.options.el.level2Holder.hoverIntent(function() {}, function() {
				self._handleMenuMouseLeave("level2holder");
			});
			/**/
			this.options.el.level3.hover(function() {
				$(this).addClass("hovered");
			}, function() {
				$(this).removeClass("hovered");
			});
			/**/
			this.options.el.menu.hoverIntent(function() {}, function() {
				self._handleMenuMouseLeave("menu");
			});
			/**/
			this.options.el.searchField.on("keyup", function() {
				clearTimeout(self.options.searchTimeout);
				self.options.searchTimeout = setTimeout(self._doSearch.bind(self), 600);
			})
		},

		_closeMenuDouble: function() {
			$(".menu__double").removeClass("card-opened net-opened");
			$(".menu__double__body").fadeOut();
		},

		_mobileEvents: function() {
			//console.log("_mobileEvents");
			var self = this;

			this.options.el.searchField.on("keyup", function() {
				$('body').addClass('searchOpened');
				clearTimeout(self.options.searchTimeout);
				self.options.searchTimeout = setTimeout(self._doSearch.bind(self), 600);
			});

			$(".menu__double__card").click(function() {
				if ($(".menu__double").hasClass("card-opened")) {
					self._closeMenuDouble();
				}
				else {
					$(".menu__double").removeClass("net-opened").addClass("card-opened");
					$(".menu__double__body-net").hide();
					$(".menu__double__body-card").show();
				}
			});

			$(".menu__double__net").click(function() {
				if ($(".menu__double").hasClass("net-opened")) {
					self._closeMenuDouble();
				}
				else {
					$(".menu__double").removeClass("card-opened").addClass("net-opened");
					$(".menu__double__body-card").hide();
					$(".menu__double__body-net").show();
				}
			});

			this.options.el.burguer.click(function() {
				self._openMobileMenu();
			});

			$(".close-mobile-menu").click(function() {
				self._closeMobileMenu();
			});
			/**/

			this.options.el.level1Options.on("click", "span", function(e) {
				var level1 = $(e.currentTarget).index() + 1;
				self._openMobileMenuLevel1(level1);
				//console.log('level1Options:click');
			});
			/**/
			this.options.el.level1Options.draggable({
				axis: "x",
				start: function(event, ui) {
					self.options.el.level1Options.stop();
					self.options.mobileItemsLeftPosition = [];
					$(".menu__level1__options.ui-draggable").find("> span").each(function() {
						var left = parseInt($(this).position().left);
						self.options.mobileItemsLeftPosition.push(left);
					});
					self.options.mobileMenuWidth = self.options.el.level1Options.width();
				},
				drag: function(event, ui) {
					//console.log(ui.position);
					var rightLimit = -self.options.mobileMenuWidth + 100;
					if (ui.position.left < rightLimit) {
						ui.position.left = rightLimit
					}
					if (ui.position.left > self.options.mobileMenuOffset) {
						ui.position.left = self.options.mobileMenuOffset
					}
				},
				stop: function(event, ui) {
					var realMenuLeft = Math.abs(ui.position.left - 50);
					var droppedIndex = self.options.mobileItemsLeftPosition.findIndex(function(value) {
						return (value + 30) >= realMenuLeft;
					});
					self._openMobileMenuLevel1(droppedIndex + 1);
					// 	if (ui.position.left > self.options.mobileMenuOffset) {
					// 		$(".menu__level1__options").animate({
					// 			left: self.options.mobileMenuOffset
					// 		}, self.options.animateSpeed)
					// 	}
				}
			});

		},

		_mobileEventsInit: function() {
			var self = this;
			/**/
			this.options.el.mobileContainer.on("click", ".inline-list.level2 > li > a", function(e) {
				e.preventDefault();
				//console.log('mobileContainer:click');
				var level1 = self.options.el.level1Options.find("span.active").index() + 1;
				var level2 = $(e.currentTarget).closest("li").index() + 1;

				if ($(e.currentTarget).parent().hasClass('active')) {
					self.options.el.mobileContainer.find(".active").removeClass("active");
				}
				else {
					self.options.el.mobileContainer.find(".active").removeClass("active");
					$(e.currentTarget).closest("li").addClass('active').index() + 1;
				}

				var whereTo = $(e.currentTarget).closest("li");

				self._openMobileMenuLevel2(level1, level2, whereTo);

				if (!$(e.currentTarget).hasClass('hasSubOptions')) {
					var href = $(e.currentTarget).attr('href');
					if (href)
						window.location.href = href;
				}
				else if ($(this).attr('href') && self.options && $(this).attr('href') != 'javascript:void(0)') {
					self.options.targetHref = $(this).attr('href');
					//console.log("options.targetHref = " + self.options.targetHref);
				}
			});

		},

		_setMenuType: function() {
			//console.log("_setMenuType", window.innerWidth);
			var self = this;
			if (window.innerWidth < 960) {
				if (this.options.menuType !== "mobile") {
					$("body").removeClass("menuDesktop desktopScrolling ").addClass("menuMobile");
					this.options.menuType = "mobile";
					this._clearAllEvents();
					this._mobileEvents();
					this._checkScroll();
				}
			}
			else {
				var active = this.options.el.level1Options.find("span.active");
				if (active.length === 0) {
					// setTimeout(function () {
					// 	self.options.el.level1Options.find("span").eq(self.options.defaultOption - 1).trigger("click");
					// }, 300);
				}
				else {
					//active.trigger("click");
					this._setDesktopMenuLevel1(self.options.defaultOption);
				}
				if (this.options.menuType !== "desktop") {
					$("body").removeClass("menuMobile mobileScrolling").addClass("menuDesktop");
					this.options.menuType = "desktop";
					this._clearAllEvents();
					this._desktopEvents();
					this._checkScroll();
				}
			}
		},

		_checkScroll: function() {
			var scrollPage = $(window).scrollTop();
			if (this.options.currentScroll > scrollPage) {
				$("body").removeClass("goingDown").addClass("goingUp");
			}
			else {
				$("body").removeClass("goingUp").addClass("goingDown");
			}
			if (scrollPage > 50) {
				if (this.options.el.body.hasClass("menuDesktop")) {
					this.options.el.body.addClass("desktopScrolling");
				}
				else if ($("body").hasClass("menuMobile")) {
					//this.options.el.body.addClass("mobileScrolling");
					//this._closeMenuDouble();					
				}
				this.options.currentScroll = scrollPage;
			}
			else {
				$("body").removeClass("mobileScrolling desktopScrolling");
			}
		},

		_setDesktopMenuLevel1: function(position, isFromClick) {
			//console.log("_setDesktopMenuLevel1", position);
			this.options.el.level1Options.find("span").removeClass("active").eq(position - 1).addClass("active");
			var markerLeft = this.options.el.level1Options.find("span.active").position().left;
			var markerWidth = this.options.el.level1Options.find("span.active").outerWidth();
			this.options.el.level3.fadeOut();
			var animationTime = isFromClick ? .4 : 0;
			TweenMax.to(".marker", animationTime, {
				left: markerLeft,
				width: markerWidth,
				ease: Power1.easeInOut
			});
			if (position !== this.currentDesktopLevel1) {
				this.currentDesktopLevel1 = position;
				this.options.el.level2Holder.find(".menu__level2__options").hide(0).eq(position - 1).fadeIn(300);
			}
			this._closeSearchBar(this.options.menuType);
		},

		_openMobileMenuLevel1: function(position) {
			// var currentLevel1 = this.options.el.level1Options.find("span.active").index() + 1;
			// if (position !== currentLevel1 || this.options.el.mobileContainer.text() === '') {
			//console.log("_openMobileMenuLevel1", position);
			this.options.el.level1Options.find("span").removeClass("active").eq(position - 1).addClass("active");
			var activeLeftPosition = this.options.el.level1Options.find("span.active").position().left;
			var nextOptions = $(".menu__level2__holder").find(".menu__level2__options").eq(position - 1).find("ul.inline-list").clone().addClass("level2");
			this.options.el.mobileContainer.empty().append(nextOptions);
			$(".menu__level1__options").stop().animate({
				left: -activeLeftPosition + this.options.mobileMenuOffset
			}, this.options.animateSpeed, "easeOutQuad");

			this.options.targetHref = this.options.el.level1Options.find("span.active").data('href');
			//console.log("options.targetHref = " + this.options.targetHref);
		},

		_showDesktopMenuLevel2: function(level1, level2) {
			//console.log('_showDesktopMenuLevel2', level1, level2);
			this.options.el.level3Options.hide(0);
			var level2Items = this.options.el.level3Options.filter("[data-level1='" + level1 + "'][data-level2='" + level2 + "']");
			this.options.el.level2.addClass("filled");
			if (level2Items.length === 0) {
				this.options.el.level3.fadeOut();
			}
			else {
				this.options.el.level3.fadeIn();
				level2Items.fadeIn();
			}
			this.options.el.level2Options.find("li:not([data-current-page=true])").removeClass("active");
			this.options.el.level2Options.eq(level1 - 1).find("li").eq(level2 - 1).addClass("active");
			//get selected level3 options
			var level3Options = this.options.el.level3Holder.find('[data-level1=' + level1 + '][data-level2=' + level2 + ']');
			//get length familyLinks and its span
			var familyLinks = level3Options.find('.menu__level3__links__family').length;
			var familyLinksSpan = level3Options.find('.menu__level3__links__family > span').length;
			var familyLinksSpanSiblings = level3Options.find('.menu__level3__links__family .menu__level3__links__title').siblings().length;
			//get heigth of family links + some height
			var countFamilyLinks = familyLinks * 60;
			//get heigth of options
			var countAllOptions = familyLinksSpan * 30;
			//calculate size to level 3 menu
			var size = (countFamilyLinks + countAllOptions) / 2;
			if (level3Options.find('.menu__level3__image').length > 0) //add 200px if level3menu has image
				size += 200;
			if (familyLinksSpanSiblings > 7 && level3Options.find('.menu__level3__image').length == 0)
				size += 200;
			//console.log(familyLinksSpanSiblings);	
			// $('.menu__level3__links__family').each(function(){
			//   var familyLinksSpanSiblings = $(this).find('span:not(.menu__level3__links__title)').length;
			//   if (familyLinksSpanSiblings>8){
			//     size += 100;
			//     console.log(familyLinksSpanSiblings);	
			//   }
			// });			

			//set max-height
			this.options.el.level3Links.css("max-height", size);
		},

		_openMobileMenuLevel2: function(level1, level2, whereTo) {

			var newMobileLevel = "'" + level1 + level2 + "'";

			this.options.el.mobileContainer.find(".menu__level3__links").remove();

			if (this.options.currentMobileLevel2 != newMobileLevel) {
				var level2Links = this.options.el.level3Options.filter("[data-level1='" + level1 + "'][data-level2='" + level2 + "']").find(".menu__level3__links").clone();
				level2Links.appendTo(whereTo);
				this.options.currentMobileLevel2 = newMobileLevel;
			}
			else {
				this.options.currentMobileLevel2 = null;
			}
		},

		_closeDesktopMenu: function() {
			this.options.el.level2Options.find("li:not([data-current-page=true])").removeClass("active");
			this.options.el.level3.fadeOut();
			this.options.el.level2.removeClass("filled");
		},

		_openMobileMenu: function() {
			this.options.currentScroll = $(document).scrollTop();
			window.scrollTo(0, 0);
			$("body").addClass("menuMobileOpened");
			if (this.options.el.level1Options.find("span.active").length === 0 || this.options.el.mobileContainer.text() === '') {
				this.options.el.level1Options.find("span").eq(this.options.defaultOption - 1).trigger("click");
			}
			else {
				var activeLeftPosition = this.options.el.level1Options.find("span.active").position().left;
				this.options.el.level1Options.animate({
					left: -activeLeftPosition + this.options.mobileMenuOffset
				}, this.options.animateSpeed);
			}
			$.publish("OPEN_MOBILE_MENU");
		},

		_closeMobileMenu: function() {
			this.options.el.level1Options.css({
				"left": "auto"
			});
			$("body").removeClass("menuMobileOpened");
			window.scrollTo(0, this.options.currentScroll);
			$.publish("CLOSE_MOBILE_MENU");
			//console.log('_closeMobileMenu');

			if (this.options.targetHref && window.location.pathname != this.options.targetHref)
				window.location.href = this.options.targetHref;
		},

		_clearAllEvents: function() {

			this.options.el.level1Options.unbind("click");
			this.options.el.level2Holder.find("li a").unbind("mouseenter mouseleave");
			this.options.el.level2Holder.unbind("mouseenter mouseleave");
			this.options.el.level3.unbind("mouseenter mouseleave");
			this.options.el.menu.unbind("mouseenter mouseleave");
			this.options.currentMobileLevel2 = null;
			$(".menu__double__card").unbind("click");
			$(".menu__double__net").unbind("click");
			this.options.el.burguer.unbind("click");
			$(".close-mobile-menu").unbind("click");
			if (this.options.el.level1Options.draggable("instance")) {
				this.options.el.level1Options.draggable("destroy");
			}
			//resize in case the search was open
			if (this.options.el.magnifier.hasClass("cross")) {
				this._openSearchBar(this.options.menuType);
			}
		},

		_openSearchBar: function(type) {
			//console.log("_openSearchBar", type);
			this.options.el.magnifier.addClass("cross");
			this.options.el.searchBar.show();
			if (type === "desktop") {
				this._closeDesktopMenu();
				this.options.el.logo.show();
				this.options.el.level2Holder.hide();
				if (!this.options.el.body.hasClass("desktopScrolling")) {
					this.options.el.level2.addClass("filled");
				}
			}
			else {
				this.options.el.logo.hide();
				this.options.el.burguer.hide();
			}
			this.options.el.searchField.val('').focus();
			$.publish("OPEN_SEARCH");
		},

		_closeSearchBar: function(type) {
			//console.log("_closeSearchBar", type);
			this.options.el.magnifier.removeClass("cross");
			this.options.el.searchBar.hide();
			this.options.el.level3.hide().removeClass("results");
			if (type === "desktop") {
				this.options.el.level2Holder.show();
			}
			else {
				this.options.el.logo.show();
				this.options.el.burguer.show();
			}
			$.publish("CLOSE_SEARCH");
		},

		_handleMenuMouseLeave: function(trigger) {
			//console.log("_handleMenuMouseLeave", trigger);
			if (this.options.el.level3.hasClass("hovered")) {
				//moved out but level 3 is visible
			}
			else if (this.options.el.magnifier.hasClass("cross")) {
				//the search bar is open
			}
			else {
				this._closeDesktopMenu();
			}
		},

		_doSearch: function() {
			var self = this;
			var query = this.options.el.searchField.val();
			//console.log("#### _doSearch : ", this.options.el.searchField.val());
			this.options.el.level2Holder.hide();
			if (query === "") {
				this.options.el.level3.fadeOut().removeClass("results");
			}
			else {
				$.ajax({
					type: "GET",
					url: this.element.data("endpoint"),
					data: 'q=' + query
				}).done(function(data, textStatus, jqXHR) {
					self._populateSearch(query, data);
				}).fail(function(data, textStatus, jqXHR) {
					self._populateSearch(query);
					//console.log("Fail:", textStatus, jqXHR);
				});
			}
		},

		_populateSearch: function(query, data) {
			this.options.el.level3.addClass("results").fadeIn();
			this.options.el.searchLabel.find("strong").text(query);
			$(".menu__level3__search-results").empty();
			$(data).each(function(index, obj) {
				//var sentence = obj.string.replace(query, "<strong>" + query + "</strong>");
				$(".menu__level3__search-results").append("<p><a href='" + obj.Url + "'>" + obj.String + "</a></p>")
			});
		},

		dump: function() {
			//console.log(this.options);
		},

		_toggleList: function() {
			var self = this;
			this.options.el.btnDropdown.on('click', function() {
				$(this).toggleClass('open')
				self.options.el.dropdownList.slideToggle()
			})
		},

		_formNet: function() {
			var self = this;
			//change forms display accordind to select value
			this.options.el.formNet.find('.menu__form__select select').each(function() {
				$(this).on('change', function() {
					var select = $(this)
					var form = $(this).closest('form')
					if (select.val() === form.attr('id')) {
						form.addClass('active')
						form.siblings().removeClass('active')
					}
					else {
						form.removeClass('active')
						form.siblings().addClass('active')
						form.siblings().find('input').val('')
						form.siblings().find('select').val(select.val())
					}
				})
			})
			this.options.el.formNet.on('focus', 'input, select', function() {
				self.options.el.formNet.addClass('focused')
			})
			this.options.el.formNet.on('focus', 'input, select', function() {
				self.options.el.formNet.addClass('focused')
			})
			this.options.el.formNet.on('blur', 'input, select', function() {
				self.options.el.formNet.removeClass('focused')
			})
		}

	});

})(jQuery);